<template>
  <div class="t-28 fw-7 onyx">Combat Encounter</div>
  <div class="combat-encounter m-tx4">
    <CombatEncounterDiceRollTicker />
    <div class="combat-encounter-body">
      <div class="f-sb">
        <CombatEncounterMonsterSearch />
        <CombatEncounterPlayerAdd />
        <button class="button bg-onyx white t-10" @click="sortCombatants">Sort On Init.</button>
        <button class="button bg-onyx white t-10" @click="openRollHistoryModal">Roll History</button>
      </div>
      <CombatEncounterCombatantList class="m-tx4" />
    </div>
    <CombatEncounterInfo class="m-lx4" />
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';
  import { useModalStore } from "../../stores/modal_store.js";
  import { useScreens } from '../../composables/screens';

  const store = useCombatEncounterStore();
  const modalStore = useModalStore();
  const { isMobile } = useScreens();

  const sortCombatants = () => { store.sortCombatants() };
  const openRollHistoryModal = () => {
    modalStore.updateModal({
      componentName: 'CombatEncounterModalsRollHistory',
    })
  };

  onMounted(() => {
    if (isMobile.value) {
      modalStore.updateModal({
        componentName: 'ModalsMobileWarning',
        closingForbidden: true,
      });
    } else {
      store.fetchUndetailedMonsters();
    }
  });
</script>